/**
 * Ask Bar hook (Phase 36.2, chunk 6)
 *
 * One plain POST. NO SSE — there is no token stream to watch, because there is
 * no model: the payload is a single small JSON object produced by a
 * deterministic parser and three bounded queries. That also avoids the raw
 * `fetch` envelope bypass the coach needed (`useCoach.ts:199-233`); `useApi()`
 * unwraps `{ success, data }` and throws a typed `ApiError`.
 *
 * No `invalidateQueries` in `onSuccess`: asking a question is a pure read and
 * changes nothing another query could be holding stale.
 */

import { useMutation } from '@tanstack/react-query';
import { useApi } from '../lib/hooks/useApi';
import type { AskResponse } from '@guild/shared';

export interface AskInput {
  question: string;
}

export function useAsk() {
  const api = useApi();

  return useMutation({
    mutationFn: (input: AskInput) => api.post<AskResponse>('/api/ask', input),
  });
}
